// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"Jtc1HzgQmCcr2Q1ml_TW"};